module.exports = __webpack_public_path__ + "img/footer_logo.9d12af9c.png";